import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './ClientsPage.css';

export default function ClientsPage() {
  const [clients, setClients]         = useState([]);
  const [search, setSearch]           = useState('');
  const [activeFilter, setActiveFilter] = useState('all');
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (search)                  params.set('search', search);
      if (activeFilter !== 'all')  params.set('active', activeFilter === 'active' ? 'true' : 'false');
      const data = await api.get(`/clients?${params}`);
      setClients(data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [search, activeFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="clients-page">
      <div className="page-header">
        <h2>Clients</h2>
        <button className="btn-primary" onClick={() => navigate('/clients/new')}>
          + Add Client
        </button>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="Search by name or email…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="search-input"
        />
        <select
          value={activeFilter}
          onChange={e => setActiveFilter(e.target.value)}
          className="filter-select"
        >
          <option value="all">All clients</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {error && <div className="error-banner">{error}</div>}

      {loading ? (
        <div className="loading">Loading…</div>
      ) : clients.length === 0 ? (
        <div className="empty-state">
          {search || activeFilter !== 'all'
            ? 'No clients match your filters.'
            : 'No clients yet. Add your first one.'}
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Company</th>
              <th>Email</th>
              <th>Contracts</th>
              <th>Invoices</th>
              <th>Status</th>
              <th>Added</th>
            </tr>
          </thead>
          <tbody>
            {clients.map(c => (
              <tr key={c.id} onClick={() => navigate(`/clients/${c.id}`)} className="clickable-row">
                <td className="name-cell">{c.name}</td>
                <td>{c.company || <span className="muted">—</span>}</td>
                <td>{c.email}</td>
                <td>{c.contractCount}</td>
                <td>{c.invoiceCount}</td>
                <td>
                  <span className={`badge ${c.isActive ? 'badge-active' : 'badge-inactive'}`}>
                    {c.isActive ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{new Date(c.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
